import { ScenarioTemplatesDependenciesComponent } from 'src/app/care/scenarios/social-networks/whatsapp/scenario-templates-dependencies/scenario-templates-dependencies.component';
import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';

export function SimpleEntrypointBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;
  let companyId = context.companyId;
  let siteId = context.site.id;
  let scenarioId = context.scenarioId;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({

    template: `
<div class="html-element receive-control-box">
  <div class="question-text-content-container">
    <div class="get-started-content">
      <div class="entrypoint-description-label"></div>
      <div class="entrypoint-description"></div>
      <div class="welcome-message-container">
        <div class="welcome-message-label">${services.$translate.instant('parameters/quick_replies/parameters/welcome_message')}:</div>
        <div class="welcome-message"></div>
      </div>
    </div>
    <div class="question-edit-container"><span class="glyphicon glyphicon-pencil question-edit"></span></div>
  </div>
  <button class="add-menu-item center-block btn btn-alcmeon-default">
    ${services.$translate.instant('parameters/quick_replies/details/add_menu_item')}
  </button>
</div>
    `,

    initialize: function () {
      switch (this.model.get('type')) {
        case 'html.GetStartedBox':
        case 'html.SurveyStartedBox':
          this.model.set("canBeDuplicated", false);
          this.model.set("canBeDeleted", false);
          break;
        case 'html.FirstConversationEverBox':
        case 'html.FollowingConversationsBox':
        case 'html.WhatsappCartSentBox':
          this.model.set("canBeDuplicated", false);
          break;
        case 'html.NewConversationBox':
          // use the default values (true and true)
          break;
        case 'html.UnexpectedUserInputBox':
        case 'html.MassMessagingEntryPointBox':
          this.model.set("canBeDuplicated", false);
          break;
      }
      this.model.set("canBeTested", false); // At the moment the backend doesn't handle testing these boxes because it expects the id of the 'next' child and we pass it the id of the box itself

      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
      this.$box.find('.question-edit').on('click', () => this.editBox());

      if (!this.isGetStartedBox() || !siteTypeConfig.hasWelcomeMessage) {
        this.$box.find('.welcome-message-container').hide();
      }
      if (this.isGetStartedBox() && siteTypeConfig.hasPersistentMenu) {
        this.$box.find('.add-menu-item').on('click', () => this.addMenuItem());
      } else {
        this.$box.find('.add-menu-item').hide();
      }
      this.updateContent();
    },


    isGetStartedBox: function () {
      return this.model.get('type') === 'html.GetStartedBox';
    },


    updateContent: function () {
      this.$box.find('.welcome-message').text(this.model.get('greeting_message'));
      this.$box.find('.entrypoint-description').text(this.model.get('entrypoint_description'));
      this.$box.find('.delay_until_first_conversation_ever').text(this.model.get('delay_until_first_conversation_ever'));
    },

    editBox: function () {
      services.$mdDialog.show({
        controller: 'editGetStartedBoxController',
        template: require('./editGetStartedBox.modal.html'),
        locals: {
          welcomeMessage: this.model.get('greeting_message'),
          entrypointDescription: this.model.get('entrypoint_description'),
          hasWelcomeMessage: this.isGetStartedBox() && siteTypeConfig.hasWelcomeMessage,
          hasComposerInputDisabled: this.isGetStartedBox() && !siteTypeConfig.getStartedBoxCannotDisableUserInput,
          composerInputDisabled: this.model.get('composer_input_disabled'),
          firstConversationEverDelay: this.model.get('delay_until_first_conversation_ever'),
          isFirstConversationEverBox: this.isFirstConversationEverBox()
        }
      }).then(res => {
        this.model.set('greeting_message', res.welcomeMessage);
        this.model.set('entrypoint_description', res.entrypointDescription);
        this.model.set('composer_input_disabled', res.composerInputDisabled);
        this.model.set('delay_until_first_conversation_ever', res.firstConversationEverDelay);
        this.updateContent();
        this.resizeBox();
        callbacks.updateSerializedGraph(this.model.graph);
      });
    },

    isFirstConversationEverBox: function () {
      return this.model.get('type') === 'html.FirstConversationEverBox';
    },

    // this uses vanilla offsetheight instead of jQuery's outerHeight(),
    // because we want a height of 0 for not displayed elements (whereas jquery tries to guestimate by creating a tmp element apparently)
    resizeBox: function () {
      if (services.JointjsOptimisationsFactory.logCallsToResize()) {
        console.warn('GetStartedBoxView - resizeBox()');
      }
      const box = this.model;
      const embeddedCells = box.getEmbeddedCells();

      const next = embeddedCells.find(c => c.get('type') === 'html.Next');

      const menuItems = embeddedCells.filter(c => c.get('type') !== 'html.Next');

      const $addMenuItem = this.$box.find('.add-menu-item');
      const $questionContent = this.$box.find('.get-started-content');

      // Reposition and resize every menu item
      let ypos = this.paddingTop();
      for (let item of menuItems) {
        const itemView = this.paper.findViewByModel(item);
        item.position(0, ypos, { parentRelative: true });

        const itemHeight = itemView.$box[0].offsetHeight;
        item.resize(box.attributes.size.width, itemHeight);
        ypos += itemHeight;
      }

      // Reposition next
      ypos += $addMenuItem[0].offsetHeight;
      next.position(0, ypos, { parentRelative: true });

      // Resize box
      let paddingTop = this.paddingTop();
      if (menuItems.length === 0) {
        paddingTop = $addMenuItem[0].offsetHeight + $questionContent[0].offsetHeight;
      }
      box.fitEmbeds({ padding: { top: paddingTop, right: 0, bottom: 0, left: 0 } });


      // Resize paper height if necessary
      callbacks.resizePaper();
    },


    createMenuItem: function (id, position, size, data) {

      const menuItem = new joint.shapes.html.MenuItem({
        id: id,
        position,
        size,
        menuItem: data
      });

      this.embedMenuItem(menuItem);
    },

    // Adds the given menuItem to the graph
    embedMenuItem: function (menuItem) {

      let getStartedBox = this.model;
      getStartedBox.embed(menuItem);
      getStartedBox.graph.addCell(menuItem);

      // caller is responsible for calling this.reorderChildren() and this.resizeBox(),
      // if and when necessary
    },

    // Adds a new menuItem with a new id; called on a add button click
    addMenuItem: function (evt) {
      this.model.getEmbeddedCells().length > 20
        ? services.AlertingFactory.warning('parameters/quick_replies/details/max_items_msg')
        : this.newMenuItemPromise().then(result => {
          services.QuickRepliesFactory.createUniqueId(companyId, siteId, scenarioId)
            .then(response => {

              this.createMenuItem(response.data.id, TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE, result.menuItem);

              this.reorderChildren();
              this.resizeBox();
            },
              services.AlertingFactory.httpErrorHandler());
        });
    },

    newMenuItemPromise: function () {
      return services.$uibModal.open({
        animation: true,
        template: require('./chooseMenuItemType.modal.html'),
        controller: 'chooseMenuItemTypeController',
        resolve: {
          menuItem: {                 // Initialize the fields of a new menuItem
            type: 'alcmeon_restart_conversation',
            title: services.$translate.instant('parameters/quick_replies/details/new_action_popin/title'),
            urlOrPayload: ''
          },

          isEditMenuItem: false,
        }
      }).result
    },


    /**
     * Overrides superclass
     * Returns the answer content's height, including image and/or error message
     */
    paddingTop: function () {
      const $questionContent = this.$box.find('.get-started-content');
      return $questionContent[0].offsetHeight;
    },

    /**
     * Overrides superclass
     * For entry point boxes, the "next" element always comes last
     */
    isChildAlwaysLast: function (child) {
      return child.get('type') === 'html.Next';
    },

    /**
     * Allows to check the usages before to delete the box. For now it is only for the Agent Shortcuts.
     */
    checkSpecificDataBeforeDeleteBox: async function () {
      if (this.model.get('type') !== 'html.AgentShortcutBox') {
        return true;
      }

      try {
        const { companyId, site, scenarioId } = context;
        const { data } = await services.QuickRepliesFactory.getAgentShortcutDependencies(companyId, site.id, scenarioId);

        const { id: boxId } = this.model;

        const dependencies = (data[scenarioId] || [])
          .filter(({ boxes }) => (boxes || []).some(({ id }) => `${id}` === `${boxId}`))
        dependencies.forEach((dependency) => dependency.scenarioId = scenarioId);

        if (!dependencies.length) {
          return true;
        }

        services.AngularMatDialog.open(ScenarioTemplatesDependenciesComponent, {
          data: {
            deleteBox: true,
            dependencies,
            siteId: site.id,
          },
        });

        return false;

      } catch (error) {

        services.AlertingFactory.alertHTTPError(error);
        return false;
      }
    }


  });
}